import { type DependencyList, useCallback, useEffect, useRef } from "react";

export const useDebounce = <Args extends unknown[]>(
  callback: (...args: Args) => void,
  timeout: number,
  dependencies: DependencyList
) => {
  const timeoutRef = useRef<number | null>(null);

  const memoizedCallback = useCallback<(...args: Args) => void>(callback, dependencies);

  const debounce = useCallback(
    (...args: Args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = window.setTimeout(() => {
        timeoutRef.current = null;
        memoizedCallback(...args);
      }, timeout);
    },
    [memoizedCallback, timeout]
  );

  useEffect(
    () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    []
  );

  return debounce;
};
